import { render, staticRenderFns } from "./RButton.vue?vue&type=template&id=5ad3d4c8&scoped=true&"
import script from "./RButton.vue?vue&type=script&lang=js&"
export * from "./RButton.vue?vue&type=script&lang=js&"
import style0 from "./RButton.vue?vue&type=style&index=0&id=5ad3d4c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad3d4c8",
  null
  
)

export default component.exports